<template>
  <v-container class="login" fluid>
    <v-card class="center-card">
      <h1>{{ $t('studentLogin') }}</h1>
      <v-card-text>
        <v-form v-model="formValid" :disabled="$store.getters.isLoading" @submit.prevent="">
          <v-text-field
            class="mb-6"
            v-model="username"
            :label="$t('account')"
            solo
            flat
            :rules="[v => $validate.required(v) || $t('message.pleaseEnterAccount')]"
            :readonly="usernameDisabled"
          ></v-text-field>
          <v-text-field
            v-model="password"
            type="password"
            :label="$t('password')"
            solo
            flat
            :rules="[v => $validate.required(v) || $t('message.pleaseEnterPassword')]"
          ></v-text-field>
          <small class="text-caption mb-10 d-block">{{ $t('studentLoginPasswordHint') }}</small>
          <FormButton
            block
            color="accent"
            class="mt-3 black--text"
            text="login"
            :disabled="!formValid"
            @click="formValid && submitLogin()"
          />
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'StudentLogin',
  data: () => ({
    formValid: false,

    username: '',
    password: '',

    usernameDisabled: false,
  }),

  methods: {
    async submitLogin() {
      if (this.$store.getters.isLoading) return

      if (!this.$validate.DataValid(this.username) || !this.$validate.DataValid(this.password)) {
        this.$store.dispatch('toggleSnack', { message: 'required', timeout: 4, allowClose: true })
        return
      }

      this.$store.dispatch('setLoading', true)
      try {
        const data = await this.$Fetcher.StudentLogin(this.username, this.password)
        await this.gfSetUserData({
          id: data.id,
          user_type: 'student',
          last_login: new Date().getTime(),
          username: data.username,
          selected_school: this.$validate.DataValid(data.schools) ? data.schools[0] : null,
          schools: data.schools,
        })

        let next = 'StudentUserDetails'
        if (this.$route.query && this.$route.query.next) {
          switch (this.$route.query.next) {
            case 'attendance':
              next = 'StudentUserAttendance'
              break
            case 'order':
              next = 'StudentUserOrderList'
              break
            case 'requirement':
              next = 'StudentSwitchRequirement'
              break
            case 'points':
              next = 'StudentUserPoints'
              break
          }
        }

        this.$router.replace({ name: next, params: { username: data.username } })
      } catch (err) {
        this.$common.error(err)
        this.$store.dispatch('toggleSnack', { type: 'error', message: err, timeout: 4, allowClose: true })
        this.$store.dispatch('setLoading', false)
      }
      return
    },
  },

  created() {
    if (this.$route.params.username) {
      this.username = this.$route.params.username
      this.usernameDisabled = true
    }
  },
}
</script>
